// extracted by mini-css-extract-plugin
export default {"title":"aa39ff090e","inner_title":"cee3d0d1ba","charge_btn":"_932e4e2fc4"};